/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AdmissionStatus } from './AdmissionStatus';
import {
    AdmissionStatusFromJSON,
    AdmissionStatusFromJSONTyped,
    AdmissionStatusToJSON,
} from './AdmissionStatus';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatus } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatus';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatusFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatusFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatusToJSON,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatus';

/**
 * 
 * @export
 * @interface InstanceBulkActionLead
 */
export interface InstanceBulkActionLead {
    /**
     * 
     * @type {string}
     * @memberof InstanceBulkActionLead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InstanceBulkActionLead
     */
    facility_name?: string;
    /**
     * 
     * @type {string}
     * @memberof InstanceBulkActionLead
     */
    source_name?: string;
    /**
     * 
     * @type {string}
     * @memberof InstanceBulkActionLead
     */
    lead_received_date: string;
    /**
     * 
     * @type {string}
     * @memberof InstanceBulkActionLead
     */
    screener_suggestion?: InstanceBulkActionLeadScreenerSuggestionEnum;
    /**
     * 
     * @type {FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatus}
     * @memberof InstanceBulkActionLead
     */
    status?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatus;
    /**
     * 
     * @type {AdmissionStatus}
     * @memberof InstanceBulkActionLead
     * @deprecated
     */
    admission_status?: AdmissionStatus;
    /**
     * 
     * @type {string}
     * @memberof InstanceBulkActionLead
     */
    connector: string;
}


/**
 * @export
 */
export const InstanceBulkActionLeadScreenerSuggestionEnum = {
    Accept: 'Accept',
    Reject: 'Reject',
    Maybe: 'Maybe',
    Pending: 'Pending',
    Cancelled: 'Cancelled',
    NA: 'N/A'
} as const;
export type InstanceBulkActionLeadScreenerSuggestionEnum = typeof InstanceBulkActionLeadScreenerSuggestionEnum[keyof typeof InstanceBulkActionLeadScreenerSuggestionEnum];


/**
 * Check if a given object implements the InstanceBulkActionLead interface.
 */
export function instanceOfInstanceBulkActionLead(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "lead_received_date" in value;
    isInstance = isInstance && "connector" in value;

    return isInstance;
}

export function InstanceBulkActionLeadFromJSON(json: any): InstanceBulkActionLead {
    return InstanceBulkActionLeadFromJSONTyped(json, false);
}

export function InstanceBulkActionLeadFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstanceBulkActionLead {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'facility_name': !exists(json, 'facility_name') ? undefined : json['facility_name'],
        'source_name': !exists(json, 'source_name') ? undefined : json['source_name'],
        'lead_received_date': json['lead_received_date'],
        'screener_suggestion': !exists(json, 'screener_suggestion') ? undefined : json['screener_suggestion'],
        'status': !exists(json, 'status') ? undefined : FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatusFromJSON(json['status']),
        'admission_status': !exists(json, 'admission_status') ? undefined : AdmissionStatusFromJSON(json['admission_status']),
        'connector': json['connector'],
    };
}

export function InstanceBulkActionLeadToJSON(value?: InstanceBulkActionLead | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'facility_name': value.facility_name,
        'source_name': value.source_name,
        'lead_received_date': value.lead_received_date,
        'screener_suggestion': value.screener_suggestion,
        'status': FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatusToJSON(value.status),
        'admission_status': AdmissionStatusToJSON(value.admission_status),
        'connector': value.connector,
    };
}

